// src/features/campus-guesser/utils/dailyLocationUtils.js
import { getTodaysDailyLocation } from '../services/locationService';

/**
 * Get today's location for the game
 * Throws error if no locations are available
 * @returns {Promise<Object>} Location object with id, imageUrl, and actualLocation
 * @throws {Error} If no active locations exist in database
 */
export async function getTodaysLocation() {
  const dailyLocation = await getTodaysDailyLocation();

  return {
    id: dailyLocation.locationId,
    imageUrl: dailyLocation.imageUrl,
    actualLocation: {
      lat: dailyLocation.actualLocation.lat,
      lng: dailyLocation.actualLocation.lng,
      name: dailyLocation.actualLocation.name || 'Unknown Location'
    }
  };
}

/**
 * Check if user has already played today's location
 * @param {string} userId
 * @param {string} locationId
 * @returns {boolean}
 */
export function hasPlayedToday(userId, locationId) {
  // This can be enhanced to check Firestore
  // For now, we rely on localStorage in the component
  return false;
}
